export enum SystemPeopleViewTab {
	IDENTIFIED = 'identified',
	UNIDENTIFIED = 'unidentified',
	HIDDEN = 'hidden',
}
